const DRIVER_TOKEN_DRIVER_UUIDS = new Set([
  '619b6cc793c45e6d471eec22',
  '6a98da2793c45e1922707609',
])

export const DRIVER_TOKEN_REVEAL_TAP_COUNT = 5

export function isDriverTokenAllowed(driverUuid: string | undefined): boolean {
  return driverUuid !== undefined && DRIVER_TOKEN_DRIVER_UUIDS.has(driverUuid)
}

export function shouldRevealDriverToken(driverUuid: string | undefined, nameTapCount: number): boolean {
  return isDriverTokenAllowed(driverUuid) && nameTapCount >= DRIVER_TOKEN_REVEAL_TAP_COUNT
}
